import React, { Suspense, forwardRef, lazy } from 'react';
import { AntLocalization } from 'ante-react-kit';
import { ensureScreenConfig } from '../config/load-config';

const loading = { vi: 'Đang tải', en: 'Loading', fr: 'Chargement', es: 'Cargando', id: 'Memuat', ja: '読み込み中', zh: '加载中', ko: '로딩 중', hi: 'लोड हो रहा है', ar: 'جارٍ التحميل' };
const retry = { vi: 'Tải lại', en: 'Reload', fr: 'Recharger', es: 'Recargar', id: 'Muat ulang', ja: '再読み込み', zh: '重新加载', ko: '새로고침', hi: 'पुनः लोड करें', ar: 'إعادة تحميل' };

class ScreenLoadBoundary extends React.Component {
    state = { error: null };
    static getDerivedStateFromError(error) { return { error }; }
    render() {
        if (this.state.error) return <button type="button" onClick={() => window.location.reload()}>{AntLocalization.translateText(retry)}</button>;
        return this.props.children;
    }
}

export default function lazyScreen(load, key) {
    // Metadata first: some existing screens read registry values at module scope.
    const Screen = lazy(async () => { await ensureScreenConfig(key); return load(); });
    const DeferredScreen = forwardRef((props, ref) => (
        <ScreenLoadBoundary>
            <Suspense fallback={<div role="status" style={{ padding: 16 }}>{AntLocalization.translateText(loading)}</div>}>
                <Screen {...props} ref={ref} />
            </Suspense>
        </ScreenLoadBoundary>
    ));
    DeferredScreen.anteConfigLazy = true;
    DeferredScreen.displayName = `LazyScreen(${key})`;
    return DeferredScreen;
}
